import { IOpenGraphMeta, ITwitterMeta } from '@/services/SEOService/metaGenerator';
import Head from 'next/head';
import React from 'react';

/**
 * SEO 최적화를 위한 속성 주입
 * @param title  페이지 타이틀
 * @param description 페이지 상세
 * @param tagKeywords 태그 문자열 배열
 * @param canonical 해당 페이지의 메인 주소
 * @param openGraph OpenGraph에 필요한 메타정보
 *
 * TODO: 이후 OpenGraph, App 연동과 관련된 메타 태그를 만드는 속성도 받아야함
 */
export interface ISunnyHeadProps {
  title: string;
  description: string;
  tagKeywords: string;
  openGraph?: IOpenGraphMeta;
  twitter?: ITwitterMeta;
}

const SunnyHead: React.FC<ISunnyHeadProps> = ({ title, description, tagKeywords, openGraph, twitter, children }) => (
  <Head>
    <meta key="description" name="description" content={description} />
    {tagKeywords && <meta key="keywords" name="keywords" content={tagKeywords} />}
    {openGraph && (
      <React.Fragment key="opengraph">
        {Object.keys(openGraph).map((key: keyof IOpenGraphMeta) => (
          <meta key={key} property={key} content={openGraph[key]} />
        ))}
      </React.Fragment>
    )}
    {twitter && (
      <React.Fragment key="twitter">
        {Object.keys(twitter).map((key: keyof ITwitterMeta) => (
          <meta key={key} name={key} content={twitter[key]} />
        ))}
      </React.Fragment>
    )}
    <title key="title">{title}</title>
    {children}
  </Head>
);

export default SunnyHead;
